import { render, staticRenderFns } from "./PurchaseInvoiceList.vue?vue&type=template&id=4c1c2dc8"
import script from "./PurchaseInvoiceList.vue?vue&type=script&lang=js"
export * from "./PurchaseInvoiceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports